import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { LeadForm } from "@/components/site/LeadForm";

// Reusable "Book a Confidential Briefing" dialog. Pass a trigger element.
export const BookingDialog = ({ trigger }) => {
  const [open, setOpen] = useState(false);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent
        data-testid="booking-dialog"
        className="max-h-[92vh] overflow-y-auto border-[color:var(--bp-border)] bg-[color:var(--bp-surface)] sm:max-w-xl"
      >
        <DialogHeader className="text-left">
          <span className="eyebrow text-[color:var(--bp-teal)]">Book a confidential briefing</span>
          <DialogTitle className="font-display text-2xl font-semibold text-[color:var(--bp-cream)]">
            A 15-minute conversation, in confidence
          </DialogTitle>
          <DialogDescription className="text-[color:var(--bp-text-muted)]">
            Tell us about your talent challenge. We&apos;ll share market intelligence relevant to your situation — no commitment required.
          </DialogDescription>
        </DialogHeader>
        <div className="mt-2">
          <LeadForm type="booking" compact onSuccess={() => setTimeout(() => setOpen(false), 900)} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
